export function importAll(cache, r) {
    r.keys().forEach((key) => (cache[key.slice(2).slice(0, -4)] = r(key)));
}
